import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const features = [
  { icon: '🛒', title: 'feature.online_ordering', slug: 'online-ordering', desc: 'feature.online_ordering_desc', color: 'bg-blue-100 text-blue-600' },
  { icon: '💳', title: 'feature.pos', slug: 'pos', desc: 'feature.pos_desc', color: 'bg-purple-100 text-purple-600' },
  { icon: '🎁', title: 'feature.loyalty', slug: 'loyalty', desc: 'feature.loyalty_desc', color: 'bg-pink-100 text-pink-600' },
  { icon: '🚚', title: 'feature.fleet', slug: 'fleet', desc: 'feature.fleet_desc', color: 'bg-orange-100 text-orange-600' },
  { icon: '📺', title: 'feature.digital_menu', slug: 'digital-menu', desc: 'feature.digital_menu_desc', color: 'bg-green-100 text-green-600' },
  { icon: '🧾', title: 'feature.kiosks', slug: 'kiosks', desc: 'feature.kiosks_desc', color: 'bg-teal-100 text-teal-600' }
];

export function FeatureGrid() {
  const { t } = useTranslation();
  return (
    <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
      {features.map((f) => (
        <div key={f.title} className="group relative rounded-2xl border border-slate-100 bg-white p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
          <div className={`w-14 h-14 rounded-xl ${f.color} flex items-center justify-center text-2xl mb-6 transition-transform group-hover:scale-110`}>
            {f.icon}
          </div>
          <h3 className="font-bold text-xl text-slate-900 mb-3 group-hover:text-teal-600 transition-colors">
            {t(f.title)}
          </h3>
          <p className="text-slate-600 leading-relaxed mb-6">
            {t(f.desc)}
          </p>
          <Link 
            to={`/solutions/${f.slug}`} 
            className="inline-flex items-center text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors"
          >
            {t('feature.learn_more', 'Learn More')}
            <svg className="w-4 h-4 ml-1 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </Link>
        </div>
      ))}
    </div>
  );
}
